
const posts = [
  {
    id: 1,
    header: "Week 1 Update: Pitching, Planning, and Progress: Solace Begins!",
    date: "2025-09-05",
    author: "Sarah Wang",
    description: `
      <h2>Introduction</h2>
      <p>We’re thrilled to announce that Solace has been selected as one of the ten projects to pitch this term! After the selection, Sarah and Esteban came together to form the team, bringing together a group of creative and dedicated members ready to bring this vision to life.</p>

      <h2>Meet the Team</h2>
      <ul>
        <li><strong>Sarah</strong> – Project Manager, Frontend Developer, Co-Product Owner</li>
        <li><strong>Esteban</strong> – Lead Developer, Co-Product Owner</li>
        <li><strong>Mateusz</strong> – Lead Designer</li>
        <li><strong>Rosie</strong> – UI/UX Designer, Scrum Master</li>
        <li><strong>Hyunjung</strong> – Brand Designer</li>
        <li><strong>Angel</strong> – UI/UX Designer</li>
        <li><strong>Zinna</strong> – AI & Backend Developer</li>
      </ul>

      <h2>Laying the Foundation</h2>
      <p>Once our team was set, we gathered to get familiar with the idea behind Solace and ensure everyone was aligned. This first conversation gave us the chance to share perspectives, ask questions, and start shaping the direction of the project together.</p>

      <h2>Sprint One: First Steps</h2>
      <p>With the vision clear, we kicked off our first sprint. Everyone jumped into action: research began, sketches of early features started to form, and the first design ideas began to emerge. Here’s how we got started:</p>
      <ul>
        <li>Zinna explored APIs</li>
        <li>Sarah and Rosie carried out a competitive analysis using Wim’s template</li>
        <li>Esteban began setting up our blog</li>
        <li>Rosie, Rachel, Angel, and Mateusz brainstormed features and drafted rough sketches</li>
        <li>Mateusz and Rachel worked on early logo concepts</li>
        <li>Sarah began user research</li>
      </ul>

      <h2>Keeping on Track</h2>
      <p>To stay organized and connected, we’ve set our weekly meetings for <strong>Mondays at 11:30 AM</strong>. These meetings give us a regular space to share progress, adjust priorities, and keep momentum strong.</p>

      <h2>Looking Ahead</h2>
      <p>The first sketches and research are already taking shape, and the energy in the team is building. We’re just at the beginning, but Solace is already moving from idea to reality—and we couldn’t be more excited to see where this journey takes us.</p>

      <p class="signature">Suffering, but make it agile,<br><br><br>— Sarah &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/introWeekImage.png"
  },
  {
    id: 2,
    header: "Week 2 Update: Logos, Features, and Mentor Wisdom",
    date: "2025-09-16",
    author: "Esteban Cruz D",
    description: `
      <h2>Introduction</h2>
      <p>Week 2 was all about identity and direction for Solace — from logos and features to research prep and our first steps in development.</p>

      <h2>Branding & Features</h2>
      <p>Our ideation crew (Rosie, Rachel, Angel, Matt) sketched out feature concepts, while Matt and Rachel drafted early logos. After some lively debate, we voted on two favorites and locked in a color palette that feels calm yet energizing.</p>

      <h2>Research Prep</h2>
      <p>Sarah led the charge on survey and interview planning, setting us up to gather real user insights in the next sprint.</p>

      <h2>Development Progress</h2>
      <p>On the dev side, Zinna researched APIs, while Esteban set up the repo and Expo environment to get the project rolling.</p>

      <h2>Mentor Check-Ins</h2>
      <p><strong>Daemon:</strong> Talked target audience, features, and branding feedback.</p>
      <p><strong>Henry:</strong> Revisited our team charter, explored AI integration, and mapped first development steps.</p>

      <h2>Looking Ahead</h2>
      <p>Rosie and Rachel started work on a project poster, and as a team we laid out our next sprint, with a focus on user research, refining designs, and building on our dev setup.</p>

      <h2>Wrap-Up</h2>
      <p>Week 2 gave us clarity — a visual identity, sharper features, and our first dev foundations. With momentum building, Week 3 is where we start putting Solace to the test.</p>

      <p>From the trenches,<br /><br /><br />— Esteban &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week2image.png"
  },
  {
    id: 3,
    header: "Week 3 Update: Progress and Development",
    date: "2025-09-24",
    author: "Zinna Kim",
    description: `
      <h2>Introduction</h2>
      <p>We’ve officially wrapped up Week 3 of our project, and the momentum is building. This week was all about digging deeper into competitive analysis, advancing our user research, and starting to shape both the design and development foundations. From setting up our technical tools to sketching low-fi features and creating a style guide, every team member contributed to moving us closer to defining our core product direction.</p>

      <h2>What We Did</h2>
      <ul>
        <li><strong>Zinna:</strong> Focused on AI research and putting up the survey poster.</li>
        <li><strong>Esteban:</strong> Worked on analysis, set up the Expo repository, researched APIs (including Expo), and drafted development criteria.</li>
        <li><strong>Mat:</strong> Developed designer criteria and established consistent styles within our Figma file.</li>
        <li><strong>Sarah:</strong> Pushed forward with front-end blog setup, conducted user interviews, and ran a user survey.</li>
        <li><strong>Rachel:</strong> Worked on survey poster design, explored logo options, sketched low-fi features, and reviewed the survey rubric.</li>
        <li><strong>Rosie:</strong> Helped with the survey poster and participated in low-fi check-in sketches.</li>
        <li><strong>Angel:</strong> Contributed to the user survey and created low-fi ideas focused on motivation and gamification.</li>
      </ul>

      <h2>Advisor Meeting</h2>
      <p>We are aiming to confirm a regular advisor meeting time. Options under consideration are Monday or Friday mornings around 11 a.m., or Wednesday at 3 p.m.</p>

      <h2>Design and Low-Fi Progress</h2>
      <p>Our design team began developing early low-fi concepts, explored check-in features, and brainstormed gamification ideas, such as caring for a pet or building a virtual house. One key decision is to ensure the design team aligns on a single, consistent style across the project.</p>

      <h2>User Research Report</h2>
      <p>Work has started on our User Research Report. Zinna is writing the introduction and summary, with action points and recommendations. Esteban is drafting the conclusion with recommendations. Rachel and Rosie are handling secondary research sections. Mat is identifying key user pain points and frustrations. Angel and Sarah are summarizing major findings, with Rosie sharing a previous report as a reference.</p>

      <h2>Next Steps for Designers</h2>
      <p>The designers are updating the style guide: Mat on typography, Angel on color palette, Rachel refining the logo, and Rosie on layout. They will apply Daemon’s feedback and continue ideating main features based on user research.</p>

      <h2>Next Steps for Developers</h2>
      <p>Sarah’s branch will be merged into the main repository for blog deployment. Blog posts will continue according to rotation: Esteban publishes Week 2, Zinna publishes Week 3, and the team reviews overall design and formatting for consistency.</p>

      <h2>Everyone’s Focus for Next Week</h2>
      <p>The entire team will finalize the User Research Report, pull the Expo repository for Sonya’s class, and continue aligning design and development with the main feature set.</p>

      <p class="signature">Testing our patience more than our features, <br/><br/>— Zinna &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week3Image.jpg"
  },
  {
    id: 4,
    header: "Week 4 Update: Building Wireframes and Shaping Features",
    date: "2025-10-02",
    author: "Mateusz Matyskiewicz",
    description: `
      <h2>Introduction</h2>
      <p>Week 4 was all about translating research into design direction and beginning to shape our core features. With user reports completed, we moved into wireframing, style guide updates, and API exploration. Our team also refined ideas around stretches, check-ins, and gamification, while continuing to align design and development for the product’s foundation.</p>

      <h2>What We Did</h2>
      <ul>
        <li><strong>Rosie:</strong> Arranged a meeting with Jenny from Forge, submitted the Competitive & User Report, created Sprint 3, and contributed to onboarding, check-in, and home wireframes. She also updated layout elements in the style guide and conducted additional research on muscle groups and related stretches.</li>
        <li><strong>Sarah:</strong> Wrote the Week 1 blog post, advanced the User Research Report, and scheduled an advisor meeting.</li>
        <li><strong>Esteban:</strong> Explored APIs, contributed to the User Research Report and its formatting, published the Week 2 blog post, and edited the survey Excel format.</li>
        <li><strong>Zinna:</strong> Published the Week 3 blog post, worked on the User Research Report, and helped refine the survey Excel format.</li>
        <li><strong>Mateusz:</strong> Focused on gamification wireframing and the User Research Report.</li>
        <li><strong>Rachel:</strong> Pushed logo design forward, completed her section of the User Research Report, researched muscle group pain points and impacts on trade workers, and began wireframing the tracking feature.</li>
      </ul>

      <h2>Wireframing & Design Feedback</h2>
      <ul>
        <li><strong>Check-in:</strong> Clear and intuitive.</li>
        <li><strong>Sleep & Mindfulness:</strong> Strong add-on, simple breathing/tips, optional by design.</li>
        <li><strong>Tracking Flow:</strong> Works smoothly.</li>
        <li><strong>Stretching:</strong> Leaning toward short standing videos rather than illustrations.</li>
        <li><strong>Gamification:</strong> Streaks and engagement mechanics are promising.</li>
      </ul>
      <p>On the UI side, we’re aligning around construction-focused features with consistent styling.</p>

      <h2>Main Features</h2>
      <p>The scope feels realistic and achievable. Core areas include: check-ins, stretching support, tracking, mindfulness/sleep features, and gamification.</p>

      <h2>Advisor Meeting</h2>
      <p>We’ll follow Henry’s meeting agenda and bring updates to Jenny during Friday’s session. Next Monday, we’ll start at 10 a.m. in the study room to kick off Sprint 4 together.</p>
      <ul>
        <li>Monday 4:30 p.m. – Designers Design Specs Meeting (can be moved to before class if needed)</li>
        <li>Wednesday 3–4 p.m. – Advisor meeting with Kenner</li>
      </ul>

      <h2>Next Steps</h2>
      <ul>
        <li><strong>Design Team:</strong> Focus on mid-fi wireframes with consistent components:
          <ul>
            <li>Rosie → Home & Main Stretch</li>
            <li>Rachel → Progress</li>
            <li>Mateusz → Gamification</li>
            <li>Angel → Mindfulness & Sleep Support</li>
            <li>Zinna → Happy Path & overall user flow</li>
          </ul>
        </li>
        <li>Logo work will move to the backlog for now.</li>
        <li><strong>Development Team:</strong> Practice building components in Expo:
          <ul>
            <li>Esteban → simple API integration</li>
            <li>Sarah → checklist component</li>
            <li>Zinna → Connecting Google Calendar to our Expo project</li>
          </ul>
        </li>
        <li><strong>Teamwide Deliverables:</strong> Completing two user personas (Sarah & Esteban) with decorated designs by Mateusz.</li>
      </ul>

      <h2>Closing</h2>
      <p>This week solidified our project’s foundation by turning research into actionable design and development steps. With wireframes, features, and personas underway, we’re well on our way to shaping Solace into a meaningful product for construction workers.</p>

      <p class="signature">Crawling out of the hole,<br/><br/>— Mateusz &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week4Image.png"
  },
  {
    id: 5,
    header: "Week 5 Update: Advisor Meeting, Building Wireframes and Logo",
    date: "2025-10-07",
    author: "Rosie Lee",
    description: `
      <h2>Introduction</h2>
      <p>In Week 5, our design team focused on refining key features such as onboarding and daily check-ins based on insights from our advisor and instructor meetings. We also made progress on our logo design to move toward finalization. Additionally, we had another valuable advisor session with Jenny, where we gained deeper insights into our target audience—trade workers—and received feedback on our overall wireframing approach.</p>
  
      <h2>What We Did</h2>
      <ul>
        <li><strong>Rosie:</strong> Designed onboarding flow, daily check-in, and home page stretch components in mid-fi; set up the meeting with Jenny; and created initial logo sketches.</li>
        <li><strong>Rachel:</strong> Worked on logo design, reviewed and edited personas based on rubric, and developed storyboard and script ideas.</li>
        <li><strong>Esteban:</strong> Updated secondary user persona, contributed to blog updates, developed storytelling ideas for personas, and tested API integration in Expo.</li>
        <li><strong>Sarah:</strong> Focused on the primary user persona, created a simple checklist component in Expo, led the advisor meeting with the agenda, researched the new target segment (ironworkers), and refined the problem statement, value proposition, and elevator pitch.</li>
        <li><strong>Mateusz:</strong> Worked on logo design concepts and user persona layout.</li>
        <li><strong>Angel:</strong> Built the information architecture, site map, and low-fidelity wireframes for “Sleep Help,” “Breathing,” “Mental Health Home,” and “To-Do List” pages.</li>
        <li><strong>Zinna:</strong> Researched APIs, tested API integration in Expo, and designed the happy path flow.</li>
        <li><strong>All:</strong> Collaborated on the site map.</li>
      </ul>
  
      <h2>Wireframing & Design Feedback</h2>
      <p>For onboarding, advisors expressed interest in push notifications to help users stay consistent despite their demanding work schedules.</p>
      <p>For check-ins, our team’s discussion highlighted the importance of integrating the user’s work schedule to ensure a seamless experience. We plan to explore how frequently their shifts change and whether they use existing scheduling platforms. This will help us create a smoother flow. Additionally, by allowing users to log their daily tasks, our AI can suggest personalized stretches that match their specific activities.</p>
  
      <h2>Main Features</h2>
      <p>Our current project scope feels realistic and achievable, focusing on these key areas:</p>
      <ul>
        <li>Daily check-ins</li>
        <li>Stretching support</li>
        <li>Progress tracking</li>
        <li>Mindfulness and sleep tools</li>
        <li>Gamification</li>
      </ul>
      <p>We are continuously refining these features based on feedback from both our instructor and advisor meetings.</p>
  
      <h2>Advisor Meeting</h2>
      <p>Here are key insights from our recent meeting with Jenny (Advisor):</p>
      <ul>
        <li><strong>Tone of Voice:</strong> Serious but with humor—use memes or celebratory messages like “Hell ya, way to go!” to keep motivation high.</li>
        <li><strong>Color Palette:</strong> Use dark tones (like black) with accent colors to create a sense of belonging—avoid clinical or “hospital” tones.</li>
        <li><strong>Scheduling:</strong> Let users input their own schedules since their shifts vary frequently and don’t follow standard office hours.</li>
        <li><strong>Marketing Insight:</strong> Emphasize how pain prevention through stretching is better than relying on chemical pain relief.</li>
        <li><strong>Target Audience:</strong> Focus on ages 20–40. A younger focus may alienate the majority of the target users.</li>
        <li><strong>Community & Stigma:</strong> There’s less stigma around discussing physical pain—many trade workers already engage in wellness activities like the gym or meditation. Encourage using the app socially.</li>
      </ul>
  
      <h2>Oct 8th – Iron Worker Field Tour with Kenner, NE12 rm 101</h2>
      <p><strong>Location:</strong> NE12</p>
      <p><strong>Summary:</strong> We toured the NE12 site, where the Iron Workers operate, and had the opportunity to observe their work environment and daily tasks.</p>
  
      <h3>Key Learnings about Iron Workers</h3>
      <ul>
        <li><strong>Teamwork:</strong> Iron workers always work in pairs for safety and efficiency.</li>
      </ul>
  
      <h4>Main Categories of Iron Work</h4>
      <ul>
        <li><strong>Structural Iron Work:</strong> Carry 50–60 lbs of steel tools on their belts while climbing, work with cranes to lift and position steel beams, and perform welding and torch cutting.</li>
        <li><strong>Reinforcement (Rebar Work):</strong> Focus on reinforcing concrete structures with rebar, requiring constant attention to detail and safety.</li>
        <li><strong>Ornamental Iron Work:</strong> Involves polishing and installing decorative or finishing metal pieces such as braces and railings.</li>
      </ul>
  
      <h4>Common Injuries</h4>
      <ul>
        <li>Lower back pain – due to heavy lifting and repetitive motion.</li>
        <li>Hand injuries – from handling steel and tools.</li>
        <li>Eye injuries – from welding, cutting, and debris.</li>
      </ul>
  
      <h4>Observations</h4>
      <p>Iron workers perform many repetitive tasks, such as lifting and carrying steel on their shoulders, setting it down, and repeating the process throughout the day. The work is physically demanding and requires constant focus on safety and team coordination. The environment is very loud, and there are dangers everywhere.</p>
  
      <h2>Next Steps</h2>
      <ul>
        <li><strong>Designers:</strong>
          <ul>
            <li>Style guide & fill any missing screens/components → Rosie</li>
            <li>Update color palette → Rachel</li>
            <li>Continue wireframing & build missing components → Rachel</li>
            <li>Logo, mascot, user scenarios, and persona layout → Mateusz</li>
            <li>Prototype & account page → Rachel & Angel</li>
          </ul>
        </li>
        <li><strong>Developers:</strong>
          <ul>
            <li>Assist with prototyping and possibly wireframing → Zinna</li>
            <li>Decide on UI library → Esteban</li>
            <li>Research and integrate AI & API for muscle use → Esteban</li>
            <li>Develop Sleep feature → Sarah</li>
            <li>Develop Breathing feature → Zinna</li>
          </ul>
        </li>
        <li><strong>User Research & Strategy:</strong>
          <ul>
            <li>Refine personas & review rubric for submission → Sarah</li>
            <li>Write user scenarios → Sarah</li>
            <li>Update elevator pitch based on new insights → Sarah</li>
          </ul>
        </li>
      </ul>
  
      <h2>Closing</h2>
      <p>Week 5 was full of progress and valuable insights. With clearer direction from our advisor, refined features, and a stronger understanding of our audience, our team is ready to move into the next phase—finalizing the style guide, completing wireframes, beginning prototyping and developing mascot and finalizing logo.</p>
  
      <p class="signature">Thanks for reading my TED Talk,<br/><br/>— Rosie &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week5Image.png"
  },
  {
    id: 6,
    header: "Week 6 Update: Refining Hi-Fi, Applying Feedback, and Preparing for User Testing",
    date: "2025-10-15",
    author: "Hyunjung Shin",
    description: `
      <h2>Introduction</h2>
      <p>In Week 6, our team focused on refining our high-fidelity designs, applying mentor and advisor feedback, and preparing for upcoming user testing. The week was full of creative collaboration, detailed review, and meaningful progress across both design and development.</p>
  
      <h2>What We Did</h2>
      <ul>
        <li><strong>Sarah:</strong> Sketched the storyboard, researched the sleep API, and wrote user persona scenarios.</li>
        <li><strong>Esteban:</strong> Created storyboard sketches, worked on the UI library, and reviewed and submitted the user persona rubric.</li>
        <li><strong>Zinna:</strong> Sketched the storyboard and designed the breathing exercise function.</li>
        <li><strong>Rosie:</strong> Developed the style guide, created storyboard sketches, and ideated and wireframed the AI push notification alarm screen.</li>
        <li><strong>Rachel:</strong> Updated the color palette, added new colors to the style guide, created wireframes for the Settings page, Navigation flow, AI version onboarding, and Dissociate (completion) screen; designed and finalized the Settings section; built missing components; and contributed to storyboard ideation and sketches.</li>
        <li><strong>Mateusz:</strong> Drew user persona scenario illustrations and developed mascot and logo concepts.</li>
        <li><strong>Angel:</strong> Contributed to storyboard ideation, prototyping, AI screen ideation, and wireframed the Account page.</li>
        <li><strong>All:</strong> Collaborated on the Advertisement Storyboards.</li>
      </ul>
  
      <h2>Wireframing & Design Feedback</h2>
      <p>Our team received valuable feedback on how to make our wireframes and overall design more cohesive and user-friendly. One of the main points was to improve the onboarding flow by adding a “Back” button on the final screen (“We’re all set”) and replacing the numerical step names like “Warm-up,” “2nd,” and “3rd” with more descriptive, non-numerical labels. These changes would make the onboarding experience smoother and more intuitive.</p>
      <p>We also learned that our gamification elements could be clearer and more consistent across the app. Clarifying the XP logic and ensuring that all related visuals align would help users better understand how progress and rewards work. Adding a short tutorial or pop-up slides explaining how the mascot and XP system function could further enhance engagement.</p>
      <p>Additionally, incorporating the user’s schedule into the home screen was highlighted as an important improvement. Showing upcoming exercises and related tasks directly on the main page will make the app better reflect the user’s daily routine. Linking exercise videos from the onboarding schedule screen will also help users start their routines more easily.</p>
      <p>Although these changes haven’t been implemented yet, our team believes that applying this feedback will make the app more consistent, engaging, and aligned with user needs. We plan to integrate these updates in the next design iteration after user testing.</p>
  
      <h2>Main Features</h2>
      <ul>
        <li>Refine visual consistency and color palette across all screens.</li>
        <li>Keep the mascot simple and meaningful—3D rendering isn’t necessary.</li>
        <li>Have the mascot represent stretching or breathing exercises.</li>
        <li>Reinforce schedule integration on the home screen as the app’s anchor.</li>
        <li>Add visuals of targeted muscle groups for each exercise.</li>
        <li>Display upcoming exercises or activities clearly within the schedule.</li>
        <li>Ensure interactive elements are visually clear for intuitive navigation.</li>
      </ul>
  
      <h2>Research & Analysis Feedback</h2>
      <p>After reviewing feedback with Wim, we identified key ways to improve the depth and clarity of our research reports:</p>
      <ul>
        <li>Make the competitive analysis more specific and detailed, avoiding overly generic insights.</li>
        <li>Expand the competitor list beyond 15 and organize findings into clear categories.</li>
        <li>In user scenarios, focus on actual user workflows and real pain points instead of hypothetical app behavior.</li>
        <li>Improve report readability by refining layout, spacing, and grouping related content together.</li>
      </ul>
  
      <h2>Advisor Meeting with Kenner</h2>
      <p>Our meeting with Kenner gave us valuable insights into how users interact with the current high-fidelity designs. We learned which elements are intuitive and engaging, and where usability could be improved. Highlights included the AI-assisted check-ins, relaxation features like white noise and breathing exercises, and flexible input options (typing and multiple selections). Users emphasized personalization options and the need for adaptable schedules to match varying work shifts.</p>
      <h3>Key Takeaways</h3>
      <ul>
        <li>Users appreciated clear task structure but want multiple or typing options for daily reports.</li>
        <li>Adding an “Enter” button would improve usability for AI-assisted inputs.</li>
        <li>White noise and rain sounds were well received and should transition smoothly with exercises.</li>
        <li>Home screen schedules should be flexible with customizable notifications.</li>
        <li>Users expressed interest in personalizing their characters beyond the default mascot.</li>
        <li>Overall, users found check-ins efficient, AI features valuable, and relaxation exercises engaging.</li>
      </ul>
  
      <h2>Next Steps</h2>
      <p>This week, our team focused on refining designs, finalizing assets, and preparing for prototyping and blog updates. The storyboard reel will be completed individually by Thursday, with Rachel drafting the next blog post.</p>
      <h3>Design Team</h3>
      <ul>
        <li>Refine wireframes for consistency and visual alignment.</li>
        <li>Fix onboarding flow and navigation clarity.</li>
        <li>Update home and gamification screens for stronger cohesion.</li>
        <li>Integrate Streak & Level indicators across all homepages (Physical, Mental, and Home).</li>
        <li>Finalize mascot and logo concepts (Mateusz).</li>
      </ul>
  
      <h3>Development Team</h3>
      <ul>
        <li><strong>Sarah:</strong> Assist with prototyping, edit blog UI with new brand colors, and create a static home screen.</li>
        <li><strong>Esteban:</strong> Build landing page (login and signup) and implement multiple-choice onboarding.</li>
        <li><strong>Zinna:</strong> Support prototyping, develop AI onboarding, and start logic for breathing exercises.</li>
      </ul>
  
      <h2>Closing</h2>
      <p>Week 6 was full of valuable feedback and actionable insights. With fresh Hi-Fi user testing feedback, mentor input, and advisor guidance, our team now has a clearer understanding of how to refine both functionality and visuals. Moving forward, we’re focused on improving onboarding, strengthening gamification, finalizing the mascot and logo, and preparing for our next round of user testing.</p>
  
      <p class="signature">Thanks for following our journey,<br/><br/>— Hyunjung &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week6Image.JPG"
  },
  {
    id: 7,
    header: "Week 7 Update: Storyboarding, Prototyping, and Midterm Prep",
    date: "2025-10-21",
    author: "Angel Hsieh",
    description: `
      <h2>Introduction</h2>
      <p>Week 7 was all about refining our user experience, advancing our prototypes, and preparing for the midterm storytelling presentation. The team made major strides on storyboards, high-fidelity design, onboarding flows, and live demo prep. Alongside coding and UI development, we focused on consistency, user testing, and connecting all parts of the product into a cohesive narrative.</p>
  
      <h2>What We Did</h2>
      <ul>
        <li><strong>Sarah:</strong> Worked on static home page coding, UI front-end for the blog, onboarding wireframes, and the storyboard for the presentation.</li>
        <li><strong>Mat:</strong> Focused on the storyboard and polishing the logo and mascot.</li>
        <li><strong>Rosie:</strong> Built a hi-fi version of the design, prototyped, and contributed to the storyboard.</li>
        <li><strong>Rachel:</strong> Updated the blog post, combined the storyboard with voiceover, recorded the voiceover, created an individual storyboard, and worked on hi-fi design and prototyping.</li>
        <li><strong>Angel:</strong> Concentrated on prototyping, wireframing, storyboard montage creation, consistency checks, and started the user testing flow.</li>
        <li><strong>Esteban:</strong> Downloaded and tested a UI library, created the LargeButton component, coded onboarding screens, worked on media queries for mobile blog progress, updated voiceovers, and pushed Hyungjung’s blog post.</li>
        <li><strong>Zinna:</strong> Coded the login, sign-in, and tutorial pages while updating storyboard sketches.</li>
      </ul>
  
      <h2>Midterm Criteria & Focus</h2>
      <ul>
        <li><strong>Product Ideation & Value Proposition:</strong> Sarah</li>
        <li><strong>Design Choices:</strong> Designers (teamwide effort)</li>
        <li><strong>Storytelling & Future Prospects:</strong> Already outlined, just fine-tuning</li>
      </ul>
  
      <h2>New User Flow (Live Demo Goal)</h2>
      <p>Sign-up → Tutorial → Onboarding (optional skip) → Home → Individual Physical → Watch Video → Finish Exercise Screen → Home → Mental → Breathing Exercise → Complete Mental → Home</p>
  
      <h2>Onboarding & Physical Section Updates</h2>
      <ul>
        <li>Sign-up now includes a fake typing animation, with working email + password input.</li>
        <li>After finishing a physical video, users are redirected to Home (no “Watch Again” button).</li>
        <li>Completed exercises on Home are crossed off.</li>
        <li>Users can earn 1 XP per exercise.</li>
        <li>A completion screen is needed for each physical exercise.</li>
        <li>Individual physical video card layouts now match the individual view.</li>
      </ul>
  
      <h2>Midterm Presentation Roles</h2>
      <ul>
        <li><strong>User Persona:</strong> Esteban</li>
        <li><strong>Mascot:</strong> Mat (with sound effect: “Congrats! You earn more XP”)</li>
        <li><strong>Design Narrator:</strong> Angel</li>
      </ul>
  
      <h2>Storytelling Outline</h2>
      <ul>
        <li><strong>Intro: Problem:</strong> Zinna</li>
        <li><strong>Value Proposition:</strong> Rachel</li>
        <li><strong>Solution:</strong> Rosie</li>
        <li><strong>Unique Features & Demo:</strong> Esteban (Ironworker) & Mat (Mascot)</li>
        <li><strong>Design Narration:</strong> Angel</li>
        <li><strong>Future Roadmap & Potential Features:</strong> Sarah</li>
        <li><strong>Conclusion:</strong> Sarah</li>
      </ul>
  
      <h2>Timeline & Next Steps</h2>
      <ul>
        <li>Storyboard done by Thursday, Oct 23</li>
        <li>Storytelling Presentation & Friday Meeting – Oct 24</li>
        <li>Script finalized – Friday after Storytelling class</li>
        <li>Practice reading script over the weekend (Zoom meeting for 10 mins)</li>
        <li>Slides design using brand colors and visuals – team members to complete their parts</li>
        <li>Blog post – Angel</li>
        <li>Next week, Kenner + 2 students will conduct user testing</li>
      </ul>
  
      <h2>Closing</h2>
      <p>Week 7 reinforced our focus on polishing the user experience, prototyping, and storytelling for the midterm. With hi-fi designs, storyboards, and a live demo flow in place, we’re on track to showcase a clear, engaging, and bug-free product demo next week.</p>
  
      <p class="signature">I’ve never wanted to git myself so much<br/><br/>We’ve never been saner!<br/><br/>— Angel &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week7Image.png"
  },
  {
    id: 8,
    header: "Week 8 Update: Storyboards, Sprints, and Midterm Magic!",
    date: "2025-10-31",
    author: "Sarah Wang",
    description: `
      <h2>Introduction</h2>
      <p>Week 8 was all about refining, rehearsing, and presenting. With our midterm approaching, the Solace team came together to tighten every detail—from design polish and live demo functionality to storytelling and presentation flow. The result? A huge step forward in bringing Solace’s vision to life with both creativity and precision.</p>
  
      <h2>What We Did</h2>
      <ul>
        <li><strong>Rosie:</strong> Set up the sprint, edited the storyboard reel, prepared for the midterm presentation, and refined the hi-fi design to align perfectly with the presentation visuals.</li>
        <li><strong>Esteban:</strong> Delegated development tasks, merged all onboarding branches, and fixed bugs across the entire onboarding process. He also made the edit-name feature functional on the homepage, matched onboarding with the new design (including animations), and coded the mental and physical homepages. Alongside Matt and Angel, he co-wrote the live demo script and presented the storyboard with Sarah.</li>
        <li><strong>Sarah:</strong> Created the midterm presentation file and wrote the script for the problem statement, future roadmap, and the conclusion. She coded the full physical exercise flow, and updated both mental and physical flows to use consistent components. She fixed multiple bugs, presented Solace at BCIT’s Celebration of Impact event, and co-wrote and co-presented the storyboard reel with Esteban. She also planned out the weekly meeting’s agenda and led the meeting.</li>
        <li><strong>Hyunjung:</strong> Enhanced the storyboard video by adding music and combining scenes, finalized the hi-fi presentation version, created presentation slides, and practiced her section on the Value Proposition. She also reviewed the storyboard for needed improvements.</li>
        <li><strong>Mateusz:</strong> Helped finalize the midterm presentation script, practiced with the team, and worked on the video replay wireframes for the hi-fi prototype.</li>
        <li><strong>Zinna:</strong> Coded the breathing exercise flow, refined the breathing cycles, and contributed to the storyboard and midterm presentation.</li>
        <li><strong>Angel:</strong> Worked on the midterm presentation script, storyboard, and wireframe fixes, ensuring design consistency throughout the demo and visuals. She also wrote last week’s blog post.</li>
      </ul>
  
      <h2>Next Sprint</h2>
      <p><strong>Blog Post:</strong> Sarah</p>
  
      <h3>Storyboard Updates (Due Wednesday):</h3>
      <ul>
        <li>Add facial expressions and match scene transitions</li>
        <li>Add transition cuts, detailed sound, setting, and dialogue</li>
        <li>Apply the Solly mascot (as discussed in class)</li>
        <li>Everyone searches for an affordable Solly costume</li>
      </ul>
  
      <h3>Props Needed:</h3>
      <ul>
        <li>Wired headphones – Angel & Sarah</li>
        <li>Pill bottles – Angel & Sarah</li>
      </ul>
  
      <h3>Design Adjustments:</h3>
      <ul>
        <li>Change character colors for distinction</li>
        <li><strong>Sarah:</strong> Change background to a yoga studio</li>
        <li><strong>Zinna:</strong> Add transition screen; remove chair (character sits on rock)</li>
        <li><strong>S3–4:</strong> Add more people and remove chair</li>
        <li><strong>S2–4:</strong> Add pain points and expressions</li>
        <li><strong>S5:</strong> Add wall transition screen</li>
        <li><strong>Angel:</strong> Plan montage sequence and draft user testing questions for Kenner</li>
        <li><strong>S6:</strong> Update phone screen visuals to match actual app UI</li>
      </ul>
  
      <h2>User Testing</h2>
      <p>Next week, the designers will focus on user testing with Jenny:</p>
      <ul>
        <li>Each designer will conduct one user test</li>
        <li>All results will be reviewed in a designers’ meeting to apply improvements</li>
        <li><strong>Angel:</strong> Write the user testing script</li>
      </ul>
      <p><strong>Developers:</strong> Updating AI code and developing more static screens.</p>
  
      <h2>Closing</h2>
      <p>Week 8 marked a pivotal moment for the Solace team as we brought our ideas to life through our midterm presentation. With strong collaboration between design and development, we successfully showcased our progress while identifying key areas for refinement. Moving forward, our focus will shift toward polishing the storyboard, integrating the mascot, and enhancing user testing to ensure Solace delivers a seamless and meaningful experience for our users.</p>
  
      <p class="signature">Testing our patience more than our features,<br/><br/>— Sarah &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week8Image.JPG"
  },
  {
    id: 9,
    header: "Week 9 Update: Polishing, Printing, and Production",
    date: "2025-11-05",
    author: "Esteban Cruz",
    description: `
      <h2>Introduction</h2>
      <p>Week 9 pushed Solace further into refinement and production. With storyboard filming underway, fresh rounds of user testing completed, and continued UI consistency improvements across the app, the project is transitioning from prototype to presentation-ready. This sprint also introduced decisions around our printed promotional materials, giving Solace a physical presence beyond the screen.</p>
  
      <h2>UI and Design Improvements</h2>
      <ul>
        <li><strong>Rosie:</strong> Updated storyboard scene 4, addressed onboarding prototype issues, and created a UI/UX feedback document to streamline communication.</li>
        <li><strong>Hyunjung:</strong> Applied feedback across multiple flows, including account settings adjustments, onboarding category separation, and upgraded card designs.</li>
        <li><strong>Angel:</strong> Performed consistency checks to standardize button sizes, spacing, and typographic hierarchy, while progressing through prototyping evaluation.</li>
        <li><strong>Rachel:</strong> Prepared motion graphics for the storyboard’s ending, sourced appropriate sound, and adjusted setting card sizing to support an About Us section.</li>
        <li><strong>Mateusz:</strong> Continued developing Solly mascot variations, favicons, and gradient shading, contributing to the evolving visual language.</li>
      </ul>
  
      <h2>User Testing and Feedback</h2>
      <p>This week included testing with advisors and external users, providing insight into comfort, pacing, and clarity of the wellness flows. The breathing exercise was reverted back to four cycles after feedback on timing. Pop notification behavior was tested for responsiveness and tone, improving how Solace communicates progress and encouragement.</p>
  
      <h2>Printed Material Ideation</h2>
      <ul>
        <li>Pull-down mascot stretch brochure</li>
        <li>Bookmark-style business cards</li>
        <li>Stress balls</li>
      </ul>
      <p>Secondary options such as stickers, pins or magnets, and mini decorative Sollys will supplement the booth with additional brand touchpoints.</p>
  
      <h2>Storyboards and Production</h2>
      <p>Filming continued this week, with several scenes shot or re-shot to improve audio quality and pacing. Earlier in the week, background ambience was recorded in NE12, providing authentic atmospheric sound for the promotional ad. With new footage captured, editing and motion graphics integration will progress into the next sprint.</p>
  
      <h2>Sprint Agenda</h2>
      <ul>
        <li>Stand-up updates</li>
        <li>Printed materials voting</li>
        <li>Feature update briefs from designers</li>
        <li>Roadmap review</li>
        <li>Open floor discussion</li>
        <li>Next sprint assignments</li>
      </ul>
      <p>With presentation day approaching, flow alignment and printed assets became primary priorities.</p>
  
      <h2>Looking Ahead</h2>
      <p>For the next sprint, everyone will prepare the presentation flow and continue work on printed deliverables. Designers will refine wireframe layouts and update the style guide, while developers will integrate those changes into the app. Additional responsibilities include onboarding UI adjustments, homepage logic, promotional website work, and continued audio editing. The team will be presenting in coordinated purple hoodies to reinforce visual identity on the final day.</p>
  
      <h2>Closing</h2>
      <p>Week 9 shifted focus toward detail: layout precision, component cleanup, user feedback integration, and physical brand materials. With momentum building, Solace is moving steadily toward its final presentation, supported by a more polished experience and a clearer sense of identity.</p>
  
      <p class="signature">Going offline before I say something I’ll have to edit later,<br/><br/>— Esteban &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week9Image.JPG"
  },

  {
    id: 10,
    header: "Week 10 Update: Final Touches, Filming, and Printed Perfection",
    date: "2025-11-10",
    author: "Zinna Kim",
    description: `
      <h2>Introduction</h2>
      <p>Week 10 marked a major turning point for the Solace team as we moved into final production and refinement. With our advertisement filming wrapping up, brochure layouts entering their final review, and UI polishing nearing completion, the project is transitioning from creation to completion. This sprint focused on finalizing deliverables, tightening up visuals, and preparing everything for our final presentation.</p>

      <h2>UI and Design Progress</h2>
      <p>The design team made significant headway in completing both digital and print assets. Rosie led the refinement of overall prototyping, updated icons for onboarding, and improved the interface for the mental-sounds section. She also finalized brochure layouts, defining typography, color systems, and text structure, while maintaining visual consistency across all printed materials.</p>
      <p>Hyunjung made significant contributions to the visual flow of the project, introducing new splash screens, updating the settings interface, and refining the Mental Home experience. She also took the lead on motion graphics for the advertisement, combining all video scenes and syncing sound effects to the mascot’s animations and transitions.</p>
      <p>Mateusz completed Version 1 of the brochure’s front and back designs, ensuring alignment with Solace’s visual identity. Angel worked alongside him to refine brochure content, review prototypes for consistency, and maintain brand cohesion across touchpoints.</p>

      <h2>Development and Content Updates</h2>
      <p>On the development side, Esteban built out multiple updates to the app and website, including a new homepage version, updated navigation components, and polished tutorial flow graphics. He continued refining the roadmap, worked on the AI info page, and began exploring the integration of a voice tool for the AI feature.</p>
      <p>Sarah coded new onboarding screens, developed promotional website elements, and enhanced CSS for layout responsiveness. She also played a key role in writing brochure content and scripting for the final presentation.</p>
      <p>Zinna wrapped up the breathing exercise pages with multiple modes, completed the static settings page, and contributed to content creation for the Solace Instagram page. Meanwhile, the team began preparing the white noise and AI integration components for the final demo.</p>

      <h2>Production and Filming</h2>
      <p>Filming continued throughout the week, with everyone contributing to shooting, editing, and refining the promotional video. Sarah led the editing of Scene 1, while Zinna and Hyunjung handled trimming, syncing, and music research. Rachel focused on combining final scenes, editing Scene 6, and organizing re-shoots to enhance quality and pacing.</p>
      <p>Authentic motion graphics were layered into scenes to showcase the app’s interface in action, giving viewers a seamless transition between real-life footage and digital visuals. The final video edit will include synchronized sound effects and music tailored to the brand tone of Solace.</p>

      <h2>Printed Materials and Physical Assets</h2>
      <p>The team finalized decisions around printed assets and their production timeline.</p>
      <h3>Brochure Timeline</h3>
      <ul>
        <li>Apply feedback by Nov. 12</li>
        <li>Final submission by Nov. 14</li>
      </ul>
      <h3>Final Deliverables by Nov. 15</h3>
      <ul>
        <li>Brochure revisions and print-ready export</li>
        <li>Business card design</li>
        <li>Stress ball and mascot file packaging</li>
        <li>Final UI/UX microinteractions update</li>
      </ul>
      <p>Additionally, Zinna confirmed shipment of Solace-branded stress balls, bringing a tangible, lighthearted touch to the brand’s final showcase.</p>

      <h2>Sprint Agenda</h2>
      <p>This week’s meeting included:</p>
      <ul>
        <li>Stand-up updates</li>
        <li>Printed materials Version 1 review</li>
        <li>Lead designer and developer roadmap check-ins</li>
        <li>Open floor discussion</li>
        <li>Next sprint planning</li>
      </ul>
      <p>The open discussion centered on final presentation flow, mirroring our midterm format but emphasizing new app functionalities:</p>
      <ul>
        <li>AI onboarding showcase</li>
        <li>Personalized homepage demo</li>
        <li>Physical and mental exercise flows (condensed versions)</li>
        <li>Presentation of physical and mental homepages</li>
      </ul>
      <p>The team also scheduled headshots for Wednesday at 12:30 PM — everyone will wear black, and Sarah and Esteban will manage camera equipment.</p>

      <h2>Looking Ahead</h2>
      <p>For the next sprint, the team will shift focus toward final presentation preparation. Designers will wrap up printed materials, ensuring all revisions are approved and submitted by Friday. Developers will finalize feature integrations, including AI onboarding, white noise functionality, and voice tool testing.</p>
      <p>The advertisement team will complete editing, combine final scenes, and synchronize music assets to create a cohesive promotional video ready for the showcase.</p>

      <h2>Wrap-Up</h2>
      <p>Week 10 brought together all aspects of Solace — from print to code, from screen to set. Every detail, from the color palette of the brochure to the timing of a scene cut, is now converging into one unified presentation. With polished visuals, refined interactions, and a growing physical presence, Solace is almost ready to step into the spotlight.</p>
      <p class="signature">Going offline before I decide to re-edit this one more time.<br/><br/>— Zinna &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week10Image.png"
  },
  {
    id: 11,
    header: "Week 11 Update: Final Sprint Push, Ads, Assets, and Presentation Prep",
    date: "2025-11-17",
    author: "Mateusz Matyskiewicz",
    description: `
      <h2>Introduction</h2>
      <p>This week marked our final major push before the end of the project. With design, development, media production, and branding all converging at once, our team focused on polishing deliverables, finishing promotional materials, refining the app experience, and preparing for the final presentation.</p>
      <p>From brochure revisions to advertisement filming to new app features like white noise, dark mode, and updated onboarding flows, the sprint was packed with momentum as we moved closer to wrapping Solace into a complete, functional product.</p>

      <h2>What We Did</h2>
      
      <h3>Rosie</h3>
      <p>Rosie kicked off the new sprint setup and finalized all printed promotional materials, including the brochure document, business card checks, and rubric verification. She also filmed ad content, completed voiceover work, edited her headshot, and contributed to the microinteraction planning for the next sprint.</p>

      <h3>Esteban</h3>
      <p>Esteban created business cards, set up SK for the project, and fully developed both onboarding flows, including the AI-assisted version. He also made the homepage checklist functional, edited his headshot, finished filming and re-recording the advertisement voiceover, and published Zinna's blog post.</p>

      <h3>Sarah</h3>
      <p>Sarah prepared and led the weekly meeting, created progress update slides, and helped film the advertisement. She rewrote the final script, began building the final presentation slides, contacted the BCCSA for permission to use their content, and recorded/cropped all exercise videos. She implemented the exercise videos into a custom API and sent Stephen the updated ad notes. She also edited her headshot.</p>

      <h3>Hyunjung</h3>
      <p>Hyunjung finalized shot lists for re-filming, edited Scene 6, and continued assembling the final cut of the advertisement. She built transitions and pain-area motion graphics, coordinated a meeting with Mak, filmed Scene 5 + additional footage, added voiceover, sourced music, and completed her headshot edit and business card updates.</p>

      <h3>Mateusz</h3>
      <p>I completed the final V2 front and back brochure covers, filmed the advertisement with the team, and edited my personal headshot.</p>

      <h3>Zinna</h3>
      <p>Zinna fully implemented the White Noise feature, researched background music for the promo video, filmed with the group, and completed her blog for the week.</p>

      <h3>Angel</h3>
      <p>Angel printed brochures, edited their headshot, and will be taking on the physical page design next sprint.</p>

      <h2>Final Presentation Prep</h2>
      <p>We reviewed the final presentation script and discussed whether certain parts should be presented live or recorded. The team will finalize this decision as we polish the presentation over the next few days.</p>
      
      <h3>Upcoming rehearsal schedule:</h3>
      <ul>
        <li>Wednesday 3 p.m. – Presentation Meeting &amp; first full run-through</li>
        <li>Friday – Practice</li>
        <li>Monday – Final practice before presentation day</li>
      </ul>

      <h2>Open Discussion &amp; Expanded Features</h2>
      <p>We assigned upcoming UI/UX feature additions:</p>
      <ul>
        <li>Dark Mode → Rachel</li>
        <li>Physical Page → Angel</li>
        <li>Font Size Adjustments (Settings) → Mateusz</li>
        <li>Microinteraction Animations → Rosie</li>
        <li>Microinteraction Sounds → Later sprint</li>
      </ul>
      <p>Work begins Tuesday at 5 p.m.</p>

      <h2>Next Sprint Focus</h2>
      
      <h3>Blog Post</h3>
      <p>Assigned to me (Mateusz)</p>

      <h3>Ad (Rachel)</h3>
      <ul>
        <li>Refine transitions</li>
        <li>Complete color collection</li>
        <li>Implement Mak's feedback</li>
      </ul>

      <h3>Development Tasks</h3>
      <ul>
        <li><strong>Sarah:</strong> Edit presentation videos &amp; integrate into the app, troubleshoot the API</li>
        <li>Developers merge Tuesday (18th)</li>
        <li><strong>Esteban:</strong> Merge Settings Page with Mental Page, then integrate with newest branch</li>
      </ul>

      <h3>Design Work</h3>
      <p>Design team begins Tuesday 5 p.m. → Thursday night to finalize all design deliverables.</p>

      <h3>Social Media</h3>
      <p><strong>Zinna:</strong> Post headshots + reels on Instagram</p>

      <h2>Closing</h2>
      <p>This sprint brought us into the final stretch of Solace's development. We wrapped up key marketing materials, recorded and refined our advertisement, pushed new app features, and began organizing the last pieces of our final presentation. With design and dev working in sync and everyone contributing across media, branding, and prototyping, Solace is entering its final form.</p>

      <p class="signature">The finish line is real,<br/><br/>— Mateusz &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week11Image.png"
  }
  ,
  {
    id: 12,
    header: "Week 12 Update: Presentation Prep & Mock-up",
    date: "2025-11-27",
    author: "Rosie Lee",
    description: `
      <h2>Introduction</h2>
      <p>Last week, we wrapped up all our printed materials—brochures, business cards, hoodies, banners—as well as our advertisements. This week was all about presentation preparation. On Wednesday, Nov. 26th, we delivered our mock-up presentation at the Telus Theatre. It felt real, exciting, and gave us a clear preview of what next Friday (Dec. 5th) will be like. The team left the stage buzzing with energy.</p>

      <h2>What We Did</h2>

      <h3>Rosie</h3>
      <ul>
        <li>Updated brochure and business card based on feedback (checked rubric &amp; submitted)</li>
        <li>Practiced presentation</li>
        <li>Created animation components for Sonya’s class — Solly scale-down animation</li>
        <li>Worked on final presentation slides</li>
      </ul>

      <h3>Esteban</h3>
      <ul>
        <li>Practiced presentation</li>
        <li>Updated onboarding flow</li>
        <li>Assigned components for designers to code</li>
        <li>Worked on final presentation slides</li>
      </ul>

      <h3>Sarah</h3>
      <ul>
        <li>Created agenda and led weekly meeting</li>
        <li>Designed progress update slides</li>
        <li>Rewrote brochure content</li>
        <li>Attended ad meeting with Mak and Stephen &amp; took notes</li>
        <li>Rewrote value proposition</li>
      </ul>

      <h3>Coding (Sarah)</h3>
      <ul>
        <li>Fixed physical-exercise video integration</li>
        <li>Added AI-powered speech bubble using OpenAI</li>
        <li>Updated Solly’s states to change based on completed exercises</li>
        <li>Added streak-increase splash screen</li>
        <li>Added “all exercises complete” button on homepage</li>
        <li>Worked on final presentation slides</li>
        <li>Rehearsed presentation with team</li>
      </ul>

      <h3>Hyunjung</h3>
      <ul>
        <li>Implemented Mak and Stephen’s feedback</li>
        <li>Added XP system for stretches (+10 XP each, total 30 XP)</li>
        <li>Updated montage shots to include before/after + new text</li>
        <li>Cut faster transitions and removed unnecessary shots</li>
        <li>Performed color correction &amp; audio adjustments</li>
        <li>Adjusted in-app text alignment</li>
        <li>Coded dark-mode components for designers</li>
        <li>Worked on final presentation slides</li>
      </ul>

      <h3>Mateusz</h3>
      <ul>
        <li>Wrote last week’s blog post</li>
        <li>Rehearsed presentation with the team</li>
        <li>Printed test versions of business cards and brochure</li>
      </ul>

      <h3>Zinna</h3>
      <ul>
        <li>Helped designers complete Sonya’s tasks</li>
        <li>Merged branches</li>
        <li>Fixed white noise pages</li>
        <li>Picked up team hoodies</li>
        <li>Attended Mak’s meeting</li>
      </ul>

      <h3>Angel</h3>
      <ul>
        <li>Rehearsed presentation with the team</li>
      </ul>

      <h2>Mock-up Presentation</h2>
      <p>Our mock-up took place at 2:30 PM on Nov. 26th. We presented first—thanks to the strong impression we made during the mid-term showcase. We’re hoping to keep that first slot for the final presentation, though the order may change depending on each team’s mock-up performance.</p>
      <p>Watching all the other teams present was inspiring. Seeing their preparation, their storytelling, and their products helped us understand what we’re doing well—and what we can improve before the real day.</p>
      <p>Overall, we’re proud of how we performed. It was exciting, motivating, and a great reminder of how far Solace has come.</p>

      <h2>Next Sprint Focus</h2>
      <h3>Developers</h3>
      <ul>
        <li><strong>Sarah:</strong> Fix video playback issue (videos ending when opening)</li>
        <li><strong>Zinna:</strong> Merge dark-mode components and onboarding animation into AISpeechBubble</li>
        <li><strong>Esteban:</strong> Push all final changes to main branch</li>
      </ul>
      <h3>Everyone</h3>
      <ul>
        <li>Practice presentation</li>
      </ul>

      <h2>Closing</h2>
      <p>Now that we’ve completed our mock-up presentation, everything feels real. We understand our product better, our flow is stronger, and we know exactly what to refine before the final showcase.</p>
      <p>Next week’s blog post? Hopefully it starts with: “We won 1st place.” We’re aiming high—and working hard.</p>
      <p class="signature">*sign off*,<br/><br/>— Rosie &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week12Image.png"
  },
  {
    id: 13,
    header: "Week 12 Update: Final Presentation & Showcase",
    date: "2025-12-06",
    author: "Hyunjung Shin",
    description: `
      <h2>Introduction</h2>
      <p>Last week, after our mock-up presentation, we decided to revise our script and redesign several slides to deliver our app story more clearly. So this entire week was fully dedicated to preparing for the final presentation. We practiced almost every day—fine-tuning the flow, adjusting transitions, and making sure our timing was consistent.</p>
      <p>On Friday, Dec 5th, we finally delivered our final presentation and promoted our app at our standing booth right after. It was a busy, intense, but exciting week.</p>

      <h2>What We Did</h2>
      <h3>Everyone</h3>
      <ul>
        <li>Prepared and practiced for the final presentation</li>
        <li>Refined the script and checked consistency between slides</li>
      </ul>

      <h2>Presentation Day</h2>
      <p>Our presentation took place at 4:30 PM on Dec 6th, and we were the first team to present—thanks to the strong impression we made during the mock-up. During the presentation, the fire alarm unexpectedly went off, which momentarily disrupted the flow of our pitch. But our team stayed calm, picked up right where we left off, and still managed to deliver confidently—and in the end, we earned second place.</p>
      <p>Watching the other teams present was truly inspiring. It felt like everyone in D3 pushed through the same challenges, late nights, and pressure together. Seeing the final results made us genuinely proud of not only our own work, but of the entire cohort.</p>
      <p>Overall, we're incredibly proud of what we achieved over the past three months. This project was exciting, motivating, and full of learning. Truly, teamwork made the dream work.</p>

      <h2>Closing</h2>
      <p>Now that the final presentation and showcase are officially over, we can finally breathe. We didn't just finish a project—we completed a journey. From the very first idea of our app to the final pitch on stage, our team grew stronger, more confident, and more aligned in what we wanted to build.</p>
      <p>This presentation may mark the end of this chapter, but it's not the end of Solace. Everything we created over the past three months is only the beginning. Our team has grown, our vision has evolved, and the foundation we built will continue to expand beyond this project.</p>
      <p>Here's to new beginnings, new skills, and everything we'll build from here.</p>
      <p>Solace isn't stopping now—we're only getting started.</p>

      <p class="signature">With pride and excitement,<br/><br/>— Hyunjung &amp; The Solace Team</p>
    `,
    image: process.env.PUBLIC_URL + "/post-images/week13Image.png"
  }
  
];

export default posts;
